import ModuleCard from '@components/student-dashboard/course-modules/module-card'
import {
  COURSE_FIRST_FOLD,
  COURSE_MODULE_DATA,
} from '@lib/data/course-landing-page'
import { CourseNameType } from '@lib/types/course-landing-page'

type Props = {
  courseName: CourseNameType
  subHeading?: string
  heading?: string
}

const CourseModule = ({ courseName, subHeading, heading }: Props) => {
  const coursesData = COURSE_FIRST_FOLD[courseName]
  const ModuleData = COURSE_MODULE_DATA[courseName]

  return (
    <div className="mt-10 lg:px-3 py-5 flex flex-col text-grey">
      <h2 className="text-2xl font-700 leading-tight">
        {heading && heading}
        {!heading && `What you'll learn from ${coursesData.name}`}
      </h2>
      <p className="font-600 mb-5">
        {subHeading && subHeading}

        {!subHeading &&
          `${coursesData.modules} Modules, ${coursesData.lessons} Lessons, ${coursesData.activities} Activities & Projects, ${coursesData.quizzes} Quizzes`}
      </p>
      <div className="grid">
        {ModuleData.map((module) => (
          <ModuleCard key={module.title} module={module} isOnCoursePage />
        ))}
      </div>
    </div>
  )
}

export default CourseModule
